import { CORE_STORE } from '@c4/core';
import { AUTH_REDUCERS } from '@c4/auth';

import { connectedDeviceReducer } from './services/connected-device.service';
import { discoveryReducer } from './services/discovery.service';
import { customDeviceReducer } from './services/custom-device.service';
import { versionsReducer } from './services/versions.service';
import { outputLogReducer } from './services/output-log.service';

export const SYSMAN_STORE: any = {
  connectedDevice: connectedDeviceReducer,
  discoveredDevices: discoveryReducer,
  customDevices: customDeviceReducer,
  versions: versionsReducer,
  outputlog: outputLogReducer
};

export const SYSMAN_REDUCERS: any = Object.assign({},
  CORE_STORE,
  AUTH_REDUCERS,
  SYSMAN_STORE
);



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/app.stores.ts